import React from "react";

const Delete = () => {
    const htmlContent = `

   <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Steps for Account Delete | Expressapp </title>
    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
</head>

<body class="bg-white">

    <div class="min-h-screen bg-white px-4 sm:px-6 lg:px-8 py-16">
        <div class="max-w-3xl mx-auto space-y-10">

            <!-- Header -->
            <header class="text-center">
                <h1 class="text-4xl font-bold" style="color: #4B63BF;">How to Delete My Account</h1>
            </header>

            <!-- Section 1 -->
            <section class="space-y-4">
                <p>
                    Deleting the account will result in your mobile number, email address, and profile name being deleted from the platform and makes all other attributes related to your Express App  account anonymous so it is no longer associated with your phone number.
                </p>
                <p>
                    If you want to delete your account from the Express App app platform, please follow the steps below:
                </p>
            </section>

            <!-- Section 2 -->
            <section class="space-y-3">
                <h2 class="text-xl font-semibold text-gray-800">iOS / Android App:</h2>

                <ul class="list-disc list-inside text-gray-700 text-justify">
                    When you register or log in, we collect:
                    <li class="ml-5 mt-2">Log in to your Express App account</li>
                    <li class="ml-5">Go To ‘Menu’ on Top Left Corner</li>
                    <li class="ml-5">Select ‘Delete My Account’</li>
                    <li class="ml-5">Click on ‘Yes to Delete Account’</li>
                    <li class="ml-5">Your account deletion will be completed in a maximum of 30 days</li>
                </ul>

                <h4 class="text-xl font-semibold mt-2" style="color: #4B63BF;">Website:</h4>
                <ul class="list-disc list-inside text-gray-700 text-justify">
                    To ensure app compatibility and security, we collect:
                    <li class="ml-5 mt-2">Log in to your Express App account with your phone number, email address, and OTP</li>
                    <li class="ml-5 mt-2">Contact us via available options at the bottom of this page and submit your request</li>
                </ul>

                <h4 class="text-xl font-semibold mt-2" style="color: #4B63BF;">Things to Note Before Deleting Your Account:</h4>
                <ul class="list-disc list-inside text-gray-700 text-justify">
                    <li class="ml-5 mt-2">Account deletion will take a maximum of 30 days.
                    </li>
                    <li class="ml-5 mt-2">Once the account is deleted, you will not be able to recover it.
                    </li>
                </ul>
        </div>
    </div>

</body>

</html>
  `;

    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};

export default Delete;
